module.exports = __webpack_public_path__ + "img/edit.e41396a6.svg";